import { Component } from '@angular/core';

import { PortalModalBaseComponent } from '../portal-modal/portal-modal-base.component';

// The WeProject Portal Terms of Use, read-only, in the shared portal modal. The text is held in the template
// rather than fetched: it is the same for every organisation, it has to be readable before anyone has a session,
// and a policy the customer is told to review shouldn't depend on a request succeeding.
//
// Every style in the template is inline, so the document depends on no class in styles.scss: it is reissued as a
// whole, and replacing it should be one paste. Colours are theme variables, because the modal surface follows the
// org's appearance setting and fixed dark text would be unreadable under a dark one.
@Component({
	selector: 'portal-terms-modal',
	templateUrl: './terms-modal.component.html'
})
export class TermsModalComponent extends PortalModalBaseComponent {

	open(): void {
		this.modal.open();
	}

}
